<template>
  <div id="EditCourse" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回課程列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <tr style="width: 70%; align: left">
            <td>
              <div>
                <span class="red_star">＊</span><span>屬性類別：</span
                ><span
                  ><b-form-select
                    class="form-control"
                    id="cidSelectText"
                    v-model="selected"
                    ref="selected"
                    @change="UpdateCid()"
                    :options="options"
                  >
                  </b-form-select
                ></span>
              </div>
            </td>
          </tr>
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>課程名稱:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData[0].courseName"
                  ref="inputData[0].courseName"
                  placeholder="課程名稱"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span><span>課程開始日期：</span>
                <span>
                  <div>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="inputData[0].sdate"
                        ref="inputData[0].sdate"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        required
                      ></b-form-input>

                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="inputData[0].sdate"
                          button-only
                          right
                          locale="zh-tw"
                          aria-controls="example-input"
                          @context="onContext"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group></div
                ></span>
              </div>

              <div>
                <span class="red_star">＊</span><span>課程結束日期：</span>
                <span>
                  <div>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="inputData[0].edate"
                        ref="inputData[0].edate"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        required
                      ></b-form-input>

                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="inputData[0].edate"
                          button-only
                          right
                          locale="zh-tw"
                          aria-controls="example-input"
                          @context="onContext"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group></div
                ></span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span><span>報名截止日期：</span>
                <span>
                  <div>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="inputData[0].closeDate"
                        ref="inputData[0].closeDate"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        required
                      ></b-form-input>

                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="inputData[0].closeDate"
                          button-only
                          right
                          locale="zh-tw"
                          aria-controls="example-input"
                          @context="onContext"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group></div
                ></span>
              </div>
            </td>
          </tr>

          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>上課時間：星期

                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData[0].weekArray"
                    value="1"
                    id="inlineCheckbox1"
                  />
                  <label class="form-check-label" for="1">一</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData[0].weekArray"
                    value="2"
                    id="inlineCheckbox2"
                  />
                  <label class="form-check-label" for="2">二</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData[0].weekArray"
                    value="3"
                    id="inlineCheckbox3"
                  />
                  <label class="form-check-label" for="3">三</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData[0].weekArray"
                    value="4"
                    id="inlineCheckbox4"
                  />
                  <label class="form-check-label" for="4">四</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData[0].weekArray"
                    value="5"
                    id="inlineCheckbox5"
                  />
                  <label class="form-check-label" for="5">五</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData[0].weekArray"
                    value="6"
                    id="inlineCheckbox6"
                  />
                  <label class="form-check-label" for="6">六</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="inputData[0].weekArray"
                    value="7"
                    id="inlineCheckbox7"
                  />
                  <label class="form-check-label" for="7">日</label>
                </div>

                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData[0].stime"
                  ref="inputData[0].stime"
                  placeholder="0800"
                  oninput="if(value.length>4)value=value.slice(0,4)"
                />~
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData[0].etime"
                  ref="inputData[0].etime"
                  placeholder="1700"
                  oninput="if(value.length>4)value=value.slice(0,4)"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>上課時數:
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData[0].courseHours"
                  ref="inputData[0].courseHours"
                  placeholder="上課時數"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>人數限制:
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData[0].primaryList"
                  ref="inputData[0].primaryList"
                  placeholder="人數限制"
                />
              </div>
            </td>
          </tr>
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>課程費用:
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData[0].courseCost"
                  ref="inputData[0].courseCost"
                  placeholder="課程費用"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>上課地點:
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="inputData[0].courseAddr"
                    :options="options2"
                    :aria-describedby="ariaDescribedby"
                    name="radio-inline"
                  ></b-form-radio-group>
                </b-form-group>

                <input
                  type="text"
                  class="form-control"
                  v-model="inputData[0].courseAddr"
                  :options="options2"
                  placeholder="上課地點"
                />
              </div>
            </td>
          </tr>

          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>聯絡專線：
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData[0].courseTel"
                  ref="inputData[0].courseTel"
                  placeholder="0123456789"
                  maxlength="10"
                />
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>聯絡Email：
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData[0].email"
                  ref="inputData[0].email"
                  placeholder="聯絡Email"
                />
              </div>
            </td>
          </tr>

          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>任課老師：
                <label style="font-size: 14px">
                  {{ inputData[0].teacherName }}
                </label>

                <b-form-select
                  text="請選擇任課老師"
                  class="select_text"
                  style="width: 20rem"
                  v-model="inputData[0].tid"
                  v-on:change="teacherClick($event)"
                >
                  <b-form-select-option
                    v-for="item in getTeacherData"
                    :key="item.tid"
                    :value="item.tid"
                    >{{ item.name }}
                  </b-form-select-option>
                </b-form-select>
                <button
                  href="#"
                  @click.prevent="getTeacherList()"
                  class="btn btn-outline-primary"
                  type="button"
                  style="font-size: 14px"
                >
                  更換老師
                </button>
              </div>
            </td>
          </tr>

          <tr align="left">
            <td>
              <div>
                <span class="red_star">＊</span>詳細網址：
                <input
                  type="text"
                  v-model="inputData[0].link"
                  ref="inputData[0].link"
                  placeholder="詳細網址"
                />
                <input
                  type="checkbox"
                  id="linkText"
                  v-model="linkText"
                  @click="addLink()"
                  aria-label="Checkbox for following text input"
                />無
              </div>
            </td>
          </tr>
          <tr align="left">
            <td>
              <span class="red_star">＊</span>課程簡介：
              <ckeditor
                :config="config"
                placeholder="請輸入課程簡介"
                v-model="inputData[0].courseIntroduce"
                ref="inputData[0].courseIntroduce"
              ></ckeditor>
            </td>
          </tr>
          <tr align="left">
            <td>
              <span class="red_star">＊</span>上傳輪播圖片
              <div class="input-group-text">
                <input
                  type="radio"
                  name="inputData[0].carousel"
                  value="false"
                  checked
                  @click="carouseChang(0)"
                  v-model="inputData[0].carousel"
                  aria-label="Radio button for following text input"
                />無

                <input
                  type="radio"
                  name="inputData[0].carousel"
                  value="true"
                  @click="carouseChang(1)"
                  v-model="inputData[0].carousel"
                  aria-label="Radio button for following text input"
                />有
              </div>
            </td>
          </tr>
          <tr align="left" v-if="mode">
            <td v-if="!empty(file[0].name)">
              <div>

                <p>
                  <a
                    :href="'./WebApi/Common/GetAttach/' + file[0].RowId"
                    target="_blank"
                    :title="file[0].name"
                  >
                    <img
                      src="@/assets/images/disk.png"
                      style="width: 1.5em; height: 1.5em"
                    />
                  </a>
                  {{ file[0] ? file[0].name : "" }}
                  　─　[<a href="#"  @click.prevent="remove(file[0].RowId)" class="item_link" >刪除</a>]
                </p>
              </div>
              <div slot="tip" class="el-upload__tip">
                上傳之檔案格式：
                <ul style="list-style-type: disc">
                  <li>副檔名.jpg、.png</li>
                  <li>檔案含英文字母共計 60 碼為檔名。</li>
                  <li>
                    檔案尺寸建議870*350像素，解析度建議150*150dpi，位元深度24，大小不得超過
                    4MB。
                  </li>
                </ul>
              </div>
              <!-- <b-button variant="warning"
              @click="clearImg()">清除<b-icon icon="trash"/></b-button> -->
            </td>
            <td v-else>
              <div>
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="file[0]"
                  @input="fileChange(0)"
                  placeholder="上傳輪播圖片"
                  accept="image/jpeg, image/png"
                ></b-form-file>
              </div>
              <div slot="tip" class="el-upload__tip">
                上傳之檔案格式：
                <ul style="list-style-type: disc">
                  <li>副檔名.jpg、.png</li>
                  <li>檔案含英文字母共計 60 碼為檔名。</li>
                  <li>
                    檔案尺寸建議870*350像素，解析度建議150*150dpi，位元深度24，大小不得超過
                    4MB。
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="EditCourse()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
     <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認刪除此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
          >取消刪除</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="RemoveUploadFile(RowId)"
          >刪除確認</b-button
        >
      </b-modal>
  </div>
</template>

<script>
import * as tools from '../tool'
import Ckeditor from 'vue-ckeditor2'
export default {
  name: 'EditCourse',
  props: ['id'],
  components: {
    Ckeditor
  },
  data () {
    return {
      AttachContent: [],
      mode: false,
      file: [{ name: '', RowId: '' }],
      inputFlag: false,
      selected: null,
      options: [
        { value: '0', text: '' },

        { value: '1', text: '現職人才培育課程' },
        { value: '2', text: '專業證照課程' },
        { value: '3', text: '創客基地課程' }
      ],
      selected2: null,
      options2: [
        { value: '工具機學院大樓3樓 VA302', text: '工具機學院大樓3樓 VA302' },
        {
          value: '工具機學院大樓4樓 多功能教室VA405',
          text: '工具機學院大樓4樓 多功能教室VA405'
        },
        { value: '', text: '其他教室' }
      ],
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: [{
        attributesClassID: 1,
        courseName: null,
        courseClass: null,
        week: null,
        sdate: null,
        edate: null,
        closeDate: null,
        stime: null,
        etime: null,
        courseHours: 0,
        weekArray: [],
        courseIntroduce: null,
        courseCost: null,
        courseAddr: null,
        courseTel: null,
        email: null,
        tid: 1,
        teacherName: null,
        primaryList: 0,
        link: null,
        carousel: false,
        info: []

      }],
      currentPage: 1,
      cid: '',
      pageSize: 10,

      config: {
        toolbar: [
          ['Source', '-', 'Preview', '-', 'Templates'],
          [
            'Cut',
            'Copy',
            'Paste',
            'PasteText',
            'PasteFromWord',
            '-',
            'Undo',
            'Redo'
          ],
          ['Find', 'Replace', '-', 'SelectAll', '-', ''],
          [
            'Bold',
            'Italic',
            'Underline',
            'Strike',
            'Subscript',
            'Superscript',
            '-',
            'CopyFormatting',
            'RemoveFormat'
          ],
          [
            'NumberedList',
            'BulletedList',
            '-',
            'Outdent',
            'Indent',
            '-',
            'Blockquote',
            'CreateDiv',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            '-',
            'BidiLtr',
            'BidiRtl',
            'Language'
          ],
          ['Link', 'Unlink', 'Anchor'],
          [
            'Image',
            'Table',
            'HorizontalRule',
            'Smiley',
            'SpecialChar',
            'PageBreak',
            'Iframe'
          ],
          ['Styles', 'Format', 'Font', 'FontSize'],
          ['TextColor', 'BGColor'],
          ['Maximize', 'ShowBlocks'],
          ['About']
        ]
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }

  },
  methods: {
    remove (RowId) {
      this.RowId = RowId
      this.$refs['q-modal'].show()
    },
    cancalRM () {
      this.$refs['q-modal'].hide()
    },
    hideModal (name) {
      this.$refs[name].hide()
      this.getAllSlide()
    },
    RemoveUploadFile (RowId) {
      this.$refs['q-modal'].hide()
      const vm = this
      this.cid = this.$props.id
      // if (this.$props.id != undefined) vm.cid = this.$props.id;
      // else vm.cid = this.$route.query.cid;

      this.AttachContent = {
        DataType: 5, // Banner type
        RowId: RowId,
        DataId: this.cid,
        Status: 'D'
      }

      this.$http
        .put('./WebApi/Setting/RemoveUploadFile/', this.AttachContent)
        .then((response) => {
          if (response.data.length > 0 || response.data == 1) {
            tools.showAlert(vm, 'success', '移除檔案成功')
            // console.log(vm.$refs["file-input"]);
            //   vm.$refs["file-input"].value = "";
            this.file[0].name = ''
            this.file[0].RowId = ''
            this.inputData[0].carousel = false
          } else {
            //     vm.$refs["file-input"].value = "";
            this.file[0].name = ''
            this.file[0].RowId = ''
            this.inputData[0].carousel = false
            tools.showAlert(vm, 'danger', '對不起,移除檔案失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    carouseChang (mode) {
      if (mode == false) {
        this.mode = false

        this.inputData[0].carousel = false
        this.file[0].name = ''
        this.file[0].RowId = ''
      } else {
        this.mode = true

        this.inputData[0].Carousel = true
      }
    },
    fileChange (index) {
      var vm = this
      this.formData = new FormData()

      if (index == 0) this.formData.append('header', this.file[0])

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) {
              this.file[0] = response.data[0]

              this.inputData[0].info = response.data
            }
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新上傳' + error)
        })
    },
    UpdateCid () {
      this.inputData[0].attributesClassID = this.selected
      this.inputData[0].courseClass = this.options[this.selected].text
    },
    empty (str) {
      if (
        str == null ||
        typeof str === 'undefined' ||
        !str ||
        str.length === 0 ||
        str === '' ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true
      } else {
        return false
      }
    },
    teacherClick (tid) {
      this.inputData[0].tid = tid
      for (var i = 0; i < this.getTeacherData.length; i++) {
        if (this.getTeacherData[i].tid == tid) {
          this.inputData[0].teacherName = this.getTeacherData[i].name
        }
      }
    },

    addLink () {
      if (document.getElementById('linkText').checked == true) { this.inputData[0].link = '無' } else this.inputData[0].link = null
    },

    checkInput () {
      if (this.empty(this.selected)) {
        alert('請選擇課程類別')
        this.$refs.selected.focus()
        this.inputFlag = true
        return
      }

      if (this.empty(this.inputData[0].courseName)) {
        alert('請輸入課程名稱')
        this.$refs['inputData[0].courseName'].focus()
        this.inputFlag = true
        return
      }

      if (this.empty(this.inputData[0].sdate)) {
        alert('請輸入課程開始日期')
        this.$refs['inputData[0].sdate'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].edate)) {
        alert('請輸入課程結束日期')
        this.$refs['inputData[0].edate'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].closeDate)) {
        alert('請輸入報名截止日期')
        this.$refs['inputData[0].closeDate'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].weekArray)) {
        alert('請輸入上課時間：星期幾')
        this.$refs['inputData[0].weekArray'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].stime)) {
        alert('請輸入課程開始時間')
        this.$refs['inputData[0].stime'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].etime)) {
        alert('請輸入課程結束時間')
        this.$refs['inputData[0].etime'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].courseHours)) {
        alert('請輸入課程總時數')
        this.$refs['inputData[0].courseHours'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].primaryList)) {
        alert('請輸入人數限制:')
        this.$refs['inputData[0].primaryList'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].courseCost)) {
        alert('請輸入課程費用')
        this.$refs['inputData[0].courseCost'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].courseAddr)) {
        alert('請輸入上課地點')
        this.$refs['inputData[0].courseAddr'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].courseTel)) {
        alert('請輸入聯絡專線')
        this.$refs['inputData[0].courseTel'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].email)) {
        alert('請輸入聯絡Email')
        this.$refs['inputData[0].email'].focus()
        this.inputFlag = true
        return
      }
      if (this.empty(this.inputData[0].link)) {
        alert('請輸入詳細網址')
        this.$refs['inputData[0].link'].focus()
        this.inputFlag = true
        return
      }
      if (this.inputData[0].courseIntroduce == null) {
        alert('請輸入課程簡介')
        this.$refs['inputData[0].courseIntroduce'].focus()
        this.inputFlag = true
      }
    },
    EditCourse () {
      this.checkInput()
      this.inputData[0].User = this.user.id

      const vm = this
      vm.cid = this.$props.id

      if (this.file.rowId == '00000000-0000-0000-0000-000000000000' && this.file.name == '') {
        this.RowId = '0'
        this.AttachContent = [{
          DataType: 5, // Banner type
          RowIdStr: this.RowId,
          DataId: this.cid,
          Status: 'A'
        }]
        this.inputData[0].info = this.AttachContent
      }

      if (this.inputFlag != true) {
        this.$http
          .put('./WebApi/ociaRep/SetociaEditCourse/', this.inputData[0])
          .then((response) => {
            if (response.data > 0) {
              tools.showAlert(vm, 'success', '更新課程成功')
              this.close()
            } else {
              tools.showAlert(vm, 'danger', '對不起,更新課程失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      }
    },
    onContext (ctx) {
      // this.inputData.sdate = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    close () {
      this.$emit('hideModal')
    },
    getTeacherList () {
      const vm = this
      this.$http
        .get('./WebApi/ociaRep/GetociaTeacherList/')
        .then((response) => {
          if (response.data.length > 0) {
            this.getTeacherData = response.data
          } else {
            tools.showAlert(vm, 'danger', '對不起,取得老師名單失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    }
  },
  created () {
    console.log('======created editCourseView =====')

    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1

    const vm = this

    vm.cid = this.$props.id
    this.$http
      .get('../WebApi/ociaRep/GetociaCourseDetail/'.concat(this.cid))
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data

          vm.selected = vm.inputData[0].attributesClassID
          if (vm.inputData[0].week.length > 1) { vm.inputData[0].weekArray = vm.inputData[0].week.split(',') } else { vm.inputData[0].weekArray = vm.inputData[0].week }

          if (
            response.data[0].carousel == true &&
            response.data[0].attachInfoString != null
          ) {
            this.mode = true
            const jsonArr = JSON.parse(response.data[0].attachInfoString)
            if (!this.empty(jsonArr)) {
              this.file[0].name = jsonArr.FileNm
              this.file[0].RowId = jsonArr.RowId
            }
          }
        }
      })
      .catch(function (error) {
        alert('網路連線失敗' + error)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
